import UAParser from 'ua-parser-js';

export const uaParserResult = new UAParser().getResult();

const isIpadOS = () =>
    /Macintosh/.test(window.navigator.userAgent) && window.navigator.maxTouchPoints > 0;

const hasCoarsePointer = () => window.matchMedia('(pointer: coarse)').matches;

export const checkIsTabletDevice = () =>
    (uaParserResult.device.type === 'tablet' || isIpadOS()) && hasCoarsePointer();
